import React from 'react';
import './LoiVersionSelect.scss';
import { Input } from 'reactstrap';
import { isLoiProcessCompleted, LoiFormsProcess } from '../../slices/marketplace/loi-comparison/models/loi-forms-process.model';

export interface LoiVersionSelectProps {
    processes: LoiFormsProcess[];
    isResubmission: boolean;
    currentLoiFormId: string | undefined;
    value: string;
    onChange: (loiFormId: string) => void;
    selectId?: string;
}

export const LoiVersionSelect = ({
    processes,
    isResubmission,
    currentLoiFormId,
    value,
    onChange,
    selectId = 'loi-version-select',
}: LoiVersionSelectProps) => {
    const completedProcesses = [...processes]
        .filter(isLoiProcessCompleted)
        .sort((a, b) => (a.completedAt ?? '').localeCompare(b.completedAt ?? ''));

    const versionOptionCount = completedProcesses.length + (isResubmission ? 1 : 0);

    if (versionOptionCount <= 1) {
        return null;
    }

    return (
        <div className="loi-version-selector">
            <label htmlFor={selectId}>Version:</label>
            <Input
                type="select"
                id={selectId}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                {completedProcesses.map((process, index) => {
                    const isLast = index === completedProcesses.length - 1;
                    const label = isLast
                        ? `Active — ${new Date(process.completedAt!).toLocaleDateString()}`
                        : new Date(process.completedAt!).toLocaleDateString();
                    return (
                        <option key={process.loiFormId} value={process.loiFormId}>
                            {label}
                        </option>
                    );
                })}
                {isResubmission && (
                    <option value={currentLoiFormId}>Resubmission</option>
                )}
            </Input>
        </div>
    );
};
